import Cookies from 'js-cookie';

const { 
    REACT_APP_NODE_ENV,
    REACT_APP_SERVER_URL
} = process.env;

console.log('process.env', process.env);

export const NODE_ENV = Cookies.get('environment') || REACT_APP_NODE_ENV;
export const SERVER_URL = Cookies.get('server_url') || REACT_APP_SERVER_URL;

console.log("PROCESS.ENV", process.env);

export const CHAT_WINDOW_MAX_WIDTH_PX = 800;

export const themeConfig = {
  palette: {
    primary: {
      main: '#1976d2',
      light: '#63a4ff',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontSize: 13,
    fontFamily: [
      '"Roboto"',
      '"Helvetica"',
      '"Arial"',
      'sans-serif',
    ].join(','),
  },
};
